import { createRoot } from "react-dom/client";

import { Main } from "@components/Main";

document.addEventListener("DOMContentLoaded", () => {
  const element = document.getElementById("index-content") as HTMLDivElement;

  if (element) {
    const { signedIn, recaptchaSiteKey, acceptedTerms, csrfToken } = element.dataset;
    const root = createRoot(element);

    root.render(
      <Main
        {...{ recaptchaSiteKey, csrfToken }}
        acceptedTerms={acceptedTerms === "true"}
        signedIn={signedIn === "true"}
      />,
    );
  }
});
